import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, of } from 'rxjs';
import { DittoService } from '../services/ditto/ditto.service';
import { NotificationsService } from '../services/notifications/notifications.service';

export const deviceDetailsGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const notifications = inject(NotificationsService);
  const translate = inject(TranslateService);
  const thingId = route.queryParamMap.get('thingId');

  if (!thingId) {
    return of(new RedirectCommand(router.parseUrl('/devices')));
  }

  return inject(DittoService)
    .getThing(thingId, { fields: ['thingId'] })
    .pipe(
      map((thing) => !!thing),
      catchError(() => {
        console.warn('Device not found, redirecting to device list');
        notifications.addNotification({
          title: translate.instant('system.errors.thingNotFound'),
          supportingTitle: thingId,
          type: 'warning',
        });

        return of(new RedirectCommand(router.parseUrl('/devices')));
      }),
    );
};
